import React from "react";
import { Box, Typography, Paper, Grid } from "@mui/material";
import axiosInstance from "../../api/axiosConfig";

const PerfilEmpresa = () => {
  const [empresa, setEmpresa] = React.useState(null);
  const [token, setToken] = React.useState("");

  React.useEffect(() => {
    const t = localStorage.getItem("token");
    setToken(t);
  }, []);

  React.useEffect(() => {
    if (!token) return;
    const fetchPerfil = async () => {
      try {
        const res = await axiosInstance.get("/api/datapersonal", {
          headers: { Authorization: token },
        });
        setEmpresa(res.data);
      } catch (error) {
        console.error("Error al obtener perfil de empresa:", error);
      }
    };
    fetchPerfil();
  }, [token]);

  if (!empresa) return <Typography>Cargando perfil...</Typography>;

  const fields = [
    { label: "Razón Social", value: empresa.reason_social },
    { label: "Nombre", value: empresa.name },
    { label: "RUC", value: empresa.ruc },
    { label: "Dirección", value: empresa.address },
    { label: "Email", value: empresa.email },
    { label: "Teléfono", value: empresa.phone },
    { label: "Estado", value: empresa.status },
    { label: "Rol", value: empresa.role },
  ];

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Perfil de Empresa
      </Typography>
      {empresa.image && (
        <Box mb={2}>
          <img
            src={empresa.image}
            alt="Logo empresa"
            style={{ width: 120, height: 120, objectFit: "cover", borderRadius: "50%" }}
          />
        </Box>
      )}
      <Paper sx={{ p: 3 }}>
        <Grid container spacing={2}>
          {fields.map((f) =>
            f.value ? (
              <Grid item xs={12} sm={6} key={f.label}>
                <Typography variant="body2" color="text.secondary">
                  {f.label}
                </Typography>
                <Typography variant="body1" fontWeight={500}>
                  {f.value}
                </Typography>
              </Grid>
            ) : null,
          )}
        </Grid>
      </Paper>
    </Box>
  );
};

export default PerfilEmpresa;
